import React from 'react';
import Moment from 'moment';

import { SERVER_ERROR_SHORT } from '../../constants/messages';
import CONSTANTS from '../../constants/constants';
import AuthMixin from '../../mixins/authenticationMixin';
import LoginStore from '../../stores/login-store';
import authAPI from '../../api/authApi';
import upgradePlans from '../../data/upgrade-plans';
import { DismissButton, ModalHeader, ModalProgress, ModalStatusIcon } from '../popups/modal-parts';

class DownGradeModal extends React.Component {
  constructor() {
    super();

    this.state = {
      title: `We're sad to see you go`,
      success: false,
      error: false,
      loading: false,
      billingDate: ''
    };
  }
  renderCurrentPlan() {
    const { account_type } = LoginStore.getSessionUserData();
    const plan = upgradePlans.find(item => item.type === account_type);

    if (!plan || !plan.price) {
      return null;
    }

    return (
      <div className="modal-plan">
        <div>
          <div className="modal-plan-name">
            {plan.type}
            <span className="modal-badge">Current plan</span>
          </div>
          <div className="modal-plan-desc">{plan.searches}</div>
        </div>
        <div className="modal-plan-price">
          &pound;{plan.price}
          {plan.abbreviation ? <small>/{plan.abbreviation}</small> : null}
        </div>
      </div>
    );
  }

  renderForm() {
    return (
      <div className="modal-body">
        <ModalHeader title={this.state.title} sub="Here's what happens if you cancel your subscription." />
        {this.renderCurrentPlan()}
        <form onSubmit={this.handSubmit.bind(this)}>
          <div className="modal-text">
            <p>
              Your unlimited access continues until the end of your current billing period. After that your
              account moves to the free Starter plan.
            </p>
            <p>If you'd rather keep your subscription, just close this window.</p>
          </div>
          <div className="modal-actions">
            <button type="submit" className="modal-btn modal-btn-danger" disabled={this.state.loading}>
              Cancel subscription
            </button>
            <DismissButton className="modal-btn modal-btn-secondary">Keep my subscription</DismissButton>
          </div>
        </form>
        {this.state.loading ? this.renderLoading() : null}
      </div>
    );
  }

  handSubmit(e) {
    e.preventDefault();
    this.setState({ loading: true });

    authAPI.cancelSubscription(this.props.userApiRequest, {
      onSuccess: ({data}) => {
        const { account_type, next_refresh } = data;
        this.setState({
          title: 'Your account has been downgraded',
          success: true,
          error: false,
          loading: false,
          billingDate: next_refresh
        });

        LoginStore.updateUser(
          this.props.userApiRequest,
          { account_type: account_type }
        );
      },
      onError: (response) => {
        this.setState({
          title: SERVER_ERROR_SHORT,
          full: response.error.error,
          error: true,
          success: false,
          loading: false
        });
      }
    });
  }

  renderSuccess() {
    return (
      <div className="modal-body is-centered">
        <ModalStatusIcon type="success" />
        <ModalHeader title={this.state.title} />
        <div className="modal-text">
          <p>
            You'll keep unlimited access until <strong>{Moment(this.state.billingDate).format('D MMMM YYYY')}</strong>,
            the end of your current billing period. After that your account moves to the free Starter plan.
          </p>
          <p>
            We'd love to know how we could do better. Email us at{' '}
            <a href={`mailto:${CONSTANTS.CONTACT_EMAIL}`}>{CONSTANTS.CONTACT_EMAIL}</a>
          </p>
        </div>
        <div className="modal-actions">
          <DismissButton className="modal-btn modal-btn-secondary">Close</DismissButton>
        </div>
      </div>
    );
  }

  renderError() {
    const { full } = this.state;

    return (
      <div className="modal-body is-centered">
        <ModalStatusIcon type="error" />
        <ModalHeader title={this.state.title} />
        <div className="modal-text">
          {full ? <p><strong>{full}</strong></p> : null}
          <p>
            If this problem persists please contact us at{' '}
            <a href={`mailto:${CONSTANTS.CONTACT_EMAIL}`}>{CONSTANTS.CONTACT_EMAIL}</a>
          </p>
        </div>
        <div className="modal-actions">
          <DismissButton className="modal-btn modal-btn-secondary">Close</DismissButton>
        </div>
      </div>
    );
  }

  renderLoading() {
    return <ModalProgress title="Cancelling your subscription…" text="Please don't close this window." />;
  }

  render() {
    const { error, success } = this.state;

    if (success) {
      return this.renderSuccess();
    }

    if (error) {
      return this.renderError();
    }

    return this.renderForm();
  }
}

export default AuthMixin(DownGradeModal);
